//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import { channelCode } from '@motionelements/core/src/helpers/channelTypes.js';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import channelTypesMixin from '@motionelements/core/src/components/mixins/channelTypes.mixin.js';
import { getChannel } from '@/helpers/channels.js';
import { getCurrencyByLang } from '@/helpers/currency.js';

export default {
  name: 'channel-page',
  components: {
    ChannelMediaTypeCategories: () => import('@/components/channels/ChannelMediaTypeCategories.vue'),
    FreeStockBanner: () => import('@/components/channels/FreeStockBanner.vue'),
    LottieDemo: () => import('@/components/channels/LottieDemo.vue'),
    HowToUseMidjourney: () => import('@/components/channels/HowToUseMidjourney.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    //
    BaseLayout: () => import('@/components/core/BaseLayout.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    NavBar: () => import('@/components/core/TheNavBar.vue'),
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    ChannelsHero: () => import('@/components/channels/ChannelsHero.vue'),
    LottieBenefits: () => import('@/components/channels/LottieBenefits.vue'),
    LottieGettingStarted: () => import('@/components/channels/LottieGettingStarted.vue'),
    CustomizeGif: () => import('@/components/channels/CustomizeGif.vue'),
    GifUseCases: () => import('@/components/channels/GifUseCases.vue'),
  },
  mixins: [featureFlagMixin, channelTypesMixin],
  props: {
    channelId: {
      type: String,
      required: true,
    },
  },
  watch: {
    userCurrency: {
      handler(toCurrencyCode) {
        if (toCurrencyCode) {
          this.$store.dispatch('subscription/getPlans');
        }
      },
      immediate: true,
    },
  },
  async fetch() {
    this.$store.dispatch('user/setCurrencyCode', getCurrencyByLang(this.$i18n.locale));
    return this.$store.dispatch('subscription/getPlans');
  },
  data() {
    return {
      channelCode,
    };
  },
  computed: {
    ...mapState({
      channelType: state => state.channels.channelType,
    }),
    ...mapGetters({
      userCurrency: 'user/currencyCode',
    }),
    isProduction() {
      return process.env.VUE_APP_ENV === 'production';
    },
    pageTitle() {
      return _.get(getChannel(this, this.channelId), 'pageTitle') || _.get(getChannel(this, this.channelId), 'heading');
    },
    pageDescription() {
      return _.get(getChannel(this, this.channelId), 'pageDescription');
    },
    // pageOgImage() {
    //   const languageCode = ['en', 'ja', 'ko', 'zh-hant'].includes(this.$i18n.locale) ? this.$i18n.locale : 'en';
    //   return `https://static.moele.me/img/motionelements-og-${languageCode}.220830.jpg`;
    // },
    channelCategories() {
      const curationsCategory = { mediaType: this.channelId, type: 'curations', heading: this.$t('term.curations') };
      const defaultCategories = [
        ...(this.showCurations && this.channelId === channelCode.SFX ? [curationsCategory] : []),
        {
          mediaType: this.channelId, type: 'category', heading: this.$t('category.categories'),
        },
      ];
      if (isProductType('video_template', this.channelId)) {
        defaultCategories.push({
          mediaType: this.channelId, type: 'style', heading: this.$t('category.styles'),
        });
      }
      switch (this.channelId) {
        case channelCode.VIDEO:
          return [
            { mediaType: 'animation', type: 'category', heading: this.renderCategoryHeading('animation') },
            { mediaType: 'video_live', type: 'category', heading: this.renderCategoryHeading('video_live') },
            // { mediaType: 'video_vr', type: 'category', heading: this.renderCategoryHeading('video_vr') },
          ];
        case channelCode.MUSIC:
          return [
            ...(this.showCurations ? [curationsCategory] : []),
            { mediaType: channelCode.MUSIC, type: 'mood', heading: this.$t('category.moods') },
            {
              mediaType: channelCode.MUSIC, type: 'genre', heading: this.$t('category.genres'), titleOnly: true, hideShowAll: true,
            },
            { mediaType: channelCode.MUSIC, type: 'category', heading: this.$t('category.production_types') },
            {
              mediaType: channelCode.MUSIC, type: 'instrument', heading: this.$t('category.instruments'), titleOnly: true,
            },
          ];
        case channelCode.IMAGE:
          return [
            { mediaType: 'photo', type: 'category', heading: this.renderCategoryHeading('photo') },
            { mediaType: 'vector', type: 'category', heading: this.renderCategoryHeading('vector') },
          ];
        case channelCode.GIF:
          return defaultCategories;
        case channelCode.IMAGE_PROMPT:
          return [
            {
              mediaType: channelCode.IMAGE_PROMPT, type: 'generator', heading: this.$t('category.ai_generators'), hideShowAll: true,
            },
            {
              mediaType: channelCode.IMAGE_PROMPT, type: 'style', heading: this.$t('category.styles'), hideShowAll: true,
            },
            {
              mediaType: channelCode.IMAGE_PROMPT, type: 'category', heading: this.$t('category.categories'), hideShowAll: true,
            },
          ];
        // case channelCode.GRAPHIC:
        //   return [
        //     { mediaType: 'graphic', type: 'category', heading: this.renderCategoryHeading('graphic_template') },
        //     { mediaType: 'vector', type: 'category', heading: this.renderCategoryHeading('vector') },
        //   ];
        default:
          return defaultCategories;
      }
    },
    showCurations() {
      return this.isFeatureEnabled('music_channel_curations');
    },
    //
    currentChannel() {
      return getChannel(this, this.channelType);
    },
    breadcrumbList() {
      let name;
      switch (this.channelType) {
        case this.channelCode.FCP:
        case this.channelCode.MUSIC:
        case this.channelCode.LOTTIE:
          name = this.$term('mediaType', this.channelType).short().text();
          break;
        case this.channelCode.VIDEO:
          name = this.$term('mediaType', this.channelType).seo().text();
          break;
        case this.channelCode['3D']:
          name = this.$term('mediaType', '3d_model').text();
          break;
        case this.channelCode.IMAGE_PROMPT:
          name = this.$term('mediaType', this.channelType).plural().text();
          break;
        default:
          name = this.$term('mediaType', this.channelType).text();
      }

      return [
        {
          name: name,
          link: this.$link(_.get(this.getChannelTypeById(this.channelType), 'link')).fullPath(),
          active: true,
        },
      ];
    },
    benefits() {
      return _.get(this.currentChannel, 'benefits');
    },
    benefitsHeading() {
      return _.get(this.currentChannel, 'benefitsHeading');
    },
    benefitsSubHeading() {
      return _.get(this.currentChannel, 'benefitsSubHeading');
    },
  },
  methods: {
    renderCategoryHeading(mediaType) {
      return this.$term('mediaType', mediaType).wbr().plural().html();
    },
    isProductType(productType, mediaType) {
      return isProductType(productType, mediaType);
    },
  },
};
